import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Select from "@cloudscape-design/components/select";
import Multiselect from "@cloudscape-design/components/multiselect";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Toggle from "@cloudscape-design/components/toggle";
import Spinner from "@cloudscape-design/components/spinner";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import { gameStore } from "../stores/games";
import { gameDetailLogModalStore, gamesAddModalStore } from "../stores/gameDetailLogModal";
import Pagination from "@cloudscape-design/components/pagination";
import Link from "@cloudscape-design/components/link";
import Table from "@cloudscape-design/components/table";
import Preferences from "@cloudscape-design/components/collection-preferences";
/* ------- */

class GameDetailLogModal extends React.Component {
	render() {
		return (
			<>
				<Modal
					visible={this.props.gameDetailLogModal.show}
					size={"max"}
					onDismiss={() => {
						this.props.setGameDetailLogModal({ ...this.props.gameDetailLogModal, show: false });
					}}
					header={`Game detail log (${this.props.gameDetailLogModal.gameID})`}
					children={
						<>
							<Table
								loading={this.props.gameDetailLogModal.loaded}
								empty="No player activity history"
								preferences={
									<Preferences
										cancelLabel="Cancel"
										confirmLabel="Confirm"
										pageSizePreference={{ title: "Game detail log per page", options: this.props.config.gameLogDetail.preferences.perPage }}
										preferences={{ pageSize: this.props.config.gameLogDetail.perPage }}
										title="Preferences"
										onConfirm={(preferences) => {
											localStorage.setItem("gameLogDetail.perPage", preferences.detail.pageSize);
											this.props.setConfig({ ...this.props.config, gameLogDetail: { ...this.props.config.gameLogDetail, perPage: preferences.detail.pageSize } });

											setTimeout(() => {
												this.props.Interface.loadLogGameDetail(this.props.gameDetailLogModal.uid, this.props.gameDetailLogModal.type, this.props.gameDetailLogModal.date, this.props.gameDetailLogModal.project, this.props.gameDetailLogModal.gameID);
											}, 250);
										}}
									/>
								}
								pagination={
									<Pagination
										disabled={this.props.gameDetailLogModal.loaded}
										currentPageIndex={this.props.gameDetailLogModal.pagination.current}
										pagesCount={this.props.gameDetailLogModal.pagination.total}
										onChange={(page) => {
											this.props.setGameDetailLogModal({ ...this.props.gameDetailLogModal, pagination: { ...this.props.gameDetailLogModal.pagination, current: page.detail.currentPageIndex } });
											setTimeout(() => {
												this.props.Interface.loadLogGameDetail(this.props.gameDetailLogModal.uid, this.props.gameDetailLogModal.type, this.props.gameDetailLogModal.date, this.props.gameDetailLogModal.project, this.props.gameDetailLogModal.gameID);
											}, 250);
										}}
									/>
								}
								columnDefinitions={[
									{ id: "date", header: "Date", cell: (item) => new Date(item.date).toLocaleDateString() + " " + new Date(item.date).toLocaleTimeString() },
									{
										id: "amount",
										header: "Amount",
										cell: (item) => (
											<Box variant="span" color={item.amount >= 0 ? (item.amount > 0 ? "text-status-success" : "text-body-secondary") : "text-status-error"}>
												{new Intl.NumberFormat("ru-RU").format(item.amount)} RUB. {typeof item.wager !== "undefined" ? <>({new Intl.NumberFormat("ru-RU").format(item.wager)} RUB.)</> : <></>}
											</Box>
										),
									},
									{ id: "from", header: "From", cell: (item) => <>{new Intl.NumberFormat("ru-RU").format(item.from / 100)} RUB.</> },
									{ id: "to", header: "To", cell: (item) => <>{new Intl.NumberFormat("ru-RU").format(item.to / 100)} RUB.</> },
								]}
								items={this.props.gameDetailLogModal.data}
							/>
						</>
					}
					footer={
						<>
							<Box
								float="right"
								children={
									<>
										<Box
											variant="span"
											margin={{ right: "s" }}
											children={
												<Button
													variant="normal"
													onClick={() => {
														this.props.setGameDetailLogModal({ ...this.props.gameDetailLogModal, show: false });
													}}
													children="Close"
												/>
											}
										/>
										<Box
											variant="span"
											children={
												<Button
													variant="primary"
													onClick={() => {
														this.addGame();
													}}
													children="Ok"
												/>
											}
										/>
									</>
								}
							/>
						</>
					}
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {

		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);

		const gameDetailLogModal = useRecoilValue(gameDetailLogModalStore);
		const setGameDetailLogModal = useSetRecoilState(gameDetailLogModalStore);

		return <Component {...props} config={config} setConfig={setConfig} gameDetailLogModal={gameDetailLogModal}  setGameDetailLogModal={setGameDetailLogModal} />;
	};
}

export default withRecoil(GameDetailLogModal);
